import { render, staticRenderFns } from "./SendGoods.vue?vue&type=template&id=18f6ac42&scoped=true"
import script from "./SendGoods.vue?vue&type=script&lang=js"
export * from "./SendGoods.vue?vue&type=script&lang=js"
import style0 from "./SendGoods.vue?vue&type=style&index=0&id=18f6ac42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f6ac42",
  null
  
)

export default component.exports